import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo
} from 'react';
import * as CategoryAPI from '../Api/Category';
import React from 'react';
export const CategoryContext = createContext();
export const useCategory = () => useContext(CategoryContext);

export const CategoryProvider = ({
  children
}) => {
  const [initialLoad, setInitialLoad] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [Categories, setCategory] = useState([]);
  const [CategoryID, setCategoryID] = useState({});


  const refreshCategory = useCallback(async() => {
    if(localStorage.getItem("auth_token") !== null){
      try {
          setError();
          setLoading(true);
          var a = []
          const data = await CategoryAPI.getAllCategory();
          data.forEach((item) => {
            for (var key in item.visibility){
                if (key === localStorage.getItem("role")){
                    if(item.visibility[key] === true){
                        a.push(item)
                    }
                }
            }
          })
          setCategory(a);
          console.log(a);
          return data;
      } catch (error) {
          setError(error);
      } finally {
          setLoading(false)
      }
    }
  }, []);




  useEffect(() => {
      if (!initialLoad) {
        refreshCategory();
        setInitialLoad(true);
      }
  }, [initialLoad, refreshCategory]);


  const getCategoryByID = useCallback(async(id) => {
    try {
        setError();
        setLoading(true);
        const data = await CategoryAPI.getCategoryByID(id);
        setCategoryID(data);
        return data;
    } catch (error) {
        setError(error);
    } finally { 
        setLoading(false)
    }

  }, []);

  const createCategory = useCallback(async(data) => {
    setError();
    setLoading(true);  
    try {
        const response = await CategoryAPI.createCategory(data);
        await refreshCategory();
        return response;
    } catch (error) {
        throw error;
    } finally {
        setLoading(false)
    }
}, [refreshCategory]);


 

  const value = useMemo(() => ({
      refreshCategory,
      Categories,
      error,
      loading,
      MVOid: CategoryID,
      getCategoryByID,
      createCategory      
  }), [refreshCategory,Categories, error, loading,CategoryID, getCategoryByID,createCategory]);

  return ( <CategoryContext.Provider value = {value} > {
          children
      } </CategoryContext.Provider>
  );
};